import {AuthorizationFetcher, utils} from '@wallaby-ui/core';
import {forOwn, isArray, omit} from 'lodash';
import {
  GRID_SORT_MODEL_SORT_COLUMN,
  GRID_SORT_MODEL_SORT_DIRECTION,
} from 'src/js/containers/grid/grid_constants';

function encodeUrlString(data) {
  return data ? encodeURIComponent(data) : '';
}
function encodeUrlParams(data) {
  const acc: string[] = [];
  forOwn(data ?? {}, (value, key) => {
    acc.push(`${key}=${encodeURIComponent(value)}`);
  });
  return acc.join('&');
}
/** @deprecated */
const SearchDataFetcher = {
  serializeFilter(filter) {
    const result = [];
    if (filter) {
      result.push(filter);
    }
    return result;
  },

  prepareSortParams(paramsSort): string {
    let sortParams = '';
    if (paramsSort) {
      if (isArray(paramsSort) && paramsSort.length > 0) {
        sortParams = paramsSort
          .map(
            (sortItem) =>
              `sort=${encodeUrlString(sortItem[GRID_SORT_MODEL_SORT_COLUMN])},${
                sortItem[GRID_SORT_MODEL_SORT_DIRECTION]
              }`
          )
          .join('&');
      } else {
        sortParams = `sort=${encodeUrlString(paramsSort)}`;
      }
    }
    return sortParams;
  },

  normalizeParams(params) {
    return {
      ...omit(params, 'sort'),
      filter: this.serializeFilter(params.filter),
      // solr spring data indexes pages from 0
      page: params.page - 1,
    };
  },

  serializeParams(params, omitSort: boolean = false): string {
    const sortParams = omitSort ? '' : this.prepareSortParams(params.sort);
    const newParams = this.normalizeParams(params);
    return `${encodeUrlParams(newParams)}${omitSort ? '' : `&${sortParams}`}`;
  },

  search(requestUrl, params) {
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}?projection=list&${this.serializeParams(params)}`,
      {method: 'get'},
      {
        'Content-Type': 'application/json',
        Timestamp: Date.now(),
      }
    )
      .then(utils.FetcherUtils.processJsonResponseWithTimestamp)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },

  exportData(requestUrl, params, exportRequestMethod, emptyExportMessage) {
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${exportRequestMethod}?projection=list&${this.serializeParams(
        params,
        true
      )}`,
      {method: 'get'},
      {'Content-Type': 'application/octet-stream'}
    )
      .then((response) => {
        return {
          exportRowsLimitReached:
            response.headers.get('ExportRowsLimitReached') === 'true',
          processedStream: utils.FetcherUtils.processOctetStreamResponse(
            response,
            true,
            true,
            ''
          ),
        };
      })
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      })
      .then((result) => {
        if (result) {
          const {processedStream, exportRowsLimitReached} = result;
          if (processedStream && processedStream.result) {
            utils.FetcherUtils.saveBlobResponse(processedStream);
            return exportRowsLimitReached;
          }
        }
        throw new Error(emptyExportMessage);
      });
  },

  getCaseTypes(requestUrl) {
    return AuthorizationFetcher.interceptedFetch(
      requestUrl,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },
};

export default SearchDataFetcher;
